/**
 * @generated SignedSource<<dc27aead0209434771c84cb1caaae451>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArtistInstagramFollowersRange = "_0_9999" | "_100000_499999" | "_10000_99999" | "_500000_inf";
export type ArtistOrdering = "date_joined_asc" | "date_joined_desc" | "growth_score_asc" | "growth_score_desc" | "instagram_followers_asc" | "instagram_followers_desc" | "spotify_monthly_listeners_asc" | "spotify_monthly_listeners_desc" | "streams_this_week_asc" | "streams_this_week_desc" | "tiktok_followers_asc" | "tiktok_followers_desc" | "tiktok_posts_asc" | "tiktok_posts_desc";
export type ArtistPartnershipStatusFilter = "NOT_LOOKING" | "OPEN";
export type ArtistSeekingServiceServiceFilter = "CONTENT_PRODUCTION" | "DISTRIBUTION" | "FUNDING" | "INDUSTRY" | "INFLUENCER" | "MARKETING";
export type ArtistSpotifyMonthlyListenersRange = "_0_99999" | "_100000_749999" | "_2000000_inf" | "_750000_1999999";
export type ArtistStreamsThisWeekRange = "_0_99999" | "_100000_749999" | "_2000000_inf" | "_750000_1999999";
export type ArtistTiktokFollowersRange = "_0_9999" | "_100000_499999" | "_10000_99999" | "_500000_inf";
export type ArtistTiktokPostsRange = "_0_2499" | "_10000_49999" | "_2500_9999" | "_50000_inf";
export type ArtistListPaginationQuery$variables = {
  count?: number | null;
  cursor?: string | null;
  displayName_Icontains?: string | null;
  genres?: ReadonlyArray<string | null> | null;
  instagramFollowers?: ReadonlyArray<ArtistInstagramFollowersRange | null> | null;
  onlyWatching?: boolean | null;
  orderBy?: ArtistOrdering | null;
  partnershipStatuses?: ReadonlyArray<ArtistPartnershipStatusFilter | null> | null;
  seekingServices?: ReadonlyArray<ArtistSeekingServiceServiceFilter | null> | null;
  spotifyMonthlyListeners?: ReadonlyArray<ArtistSpotifyMonthlyListenersRange | null> | null;
  streamsThisWeek?: ReadonlyArray<ArtistStreamsThisWeekRange | null> | null;
  tiktokFollowers?: ReadonlyArray<ArtistTiktokFollowersRange | null> | null;
  tiktokPosts?: ReadonlyArray<ArtistTiktokPostsRange | null> | null;
};
export type ArtistListPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ArtistDirectoryCards_allArtists">;
};
export type ArtistListPaginationQuery = {
  response: ArtistListPaginationQuery$data;
  variables: ArtistListPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 6,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "displayName_Icontains"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "genres"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "instagramFollowers"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "onlyWatching"
  },
  {
    "defaultValue": "growth_score_desc",
    "kind": "LocalArgument",
    "name": "orderBy"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "partnershipStatuses"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "seekingServices"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spotifyMonthlyListeners"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamsThisWeek"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tiktokFollowers"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tiktokPosts"
  }
],
v1 = {
  "kind": "Variable",
  "name": "displayName_Icontains",
  "variableName": "displayName_Icontains"
},
v2 = {
  "kind": "Variable",
  "name": "genres",
  "variableName": "genres"
},
v3 = {
  "kind": "Variable",
  "name": "instagramFollowers",
  "variableName": "instagramFollowers"
},
v4 = {
  "kind": "Variable",
  "name": "onlyWatching",
  "variableName": "onlyWatching"
},
v5 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v6 = {
  "kind": "Variable",
  "name": "partnershipStatuses",
  "variableName": "partnershipStatuses"
},
v7 = {
  "kind": "Variable",
  "name": "seekingServices",
  "variableName": "seekingServices"
},
v8 = {
  "kind": "Variable",
  "name": "spotifyMonthlyListeners",
  "variableName": "spotifyMonthlyListeners"
},
v9 = {
  "kind": "Variable",
  "name": "streamsThisWeek",
  "variableName": "streamsThisWeek"
},
v10 = {
  "kind": "Variable",
  "name": "tiktokFollowers",
  "variableName": "tiktokFollowers"
},
v11 = {
  "kind": "Variable",
  "name": "tiktokPosts",
  "variableName": "tiktokPosts"
},
v12 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "current",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percentChange",
  "storageKey": null
},
v17 = [
  (v15/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ArtistListPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "ArtistDirectoryCards_allArtists"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ArtistListPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v12/*: any*/),
        "concreteType": "ArtistNodeConnection",
        "kind": "LinkedField",
        "name": "allArtists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArtistNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ArtistNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNode",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastActiveAt",
                        "storageKey": null
                      },
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "partnershipStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArtistSeekingServiceNodeConnection",
                    "kind": "LinkedField",
                    "name": "seekingServices",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArtistSeekingServiceNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ArtistSeekingServiceNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "service",
                                "storageKey": null
                              },
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GenreNode",
                    "kind": "LinkedField",
                    "name": "genre",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "genre",
                        "storageKey": null
                      },
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatWithDelta",
                    "kind": "LinkedField",
                    "name": "latestSpotifyMonthlyListenerCount",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatWithDelta",
                    "kind": "LinkedField",
                    "name": "latestSpotifyFollowerCount",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileNode",
                    "kind": "LinkedField",
                    "name": "spotifyProfile",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v18/*: any*/),
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatWithDelta",
                    "kind": "LinkedField",
                    "name": "latestTiktokFollowerCount",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileNode",
                    "kind": "LinkedField",
                    "name": "tiktokProfile",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TikTokSoundNodeConnection",
                        "kind": "LinkedField",
                        "name": "tiktokSounds",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TikTokSoundNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TikTokSoundNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tiktokUrl",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StatWithDelta",
                                    "kind": "LinkedField",
                                    "name": "mostRecentStat",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "previous",
                                        "storageKey": null
                                      },
                                      (v16/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v13/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatWithDelta",
                    "kind": "LinkedField",
                    "name": "latestInstagramFollowerCount",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileNode",
                    "kind": "LinkedField",
                    "name": "instagramProfile",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v12/*: any*/),
        "filters": [
          "orderBy",
          "displayName_Icontains",
          "onlyWatching",
          "genres",
          "partnershipStatuses",
          "seekingServices",
          "streamsThisWeek",
          "spotifyMonthlyListeners",
          "tiktokPosts",
          "tiktokFollowers",
          "instagramFollowers"
        ],
        "handle": "connection",
        "key": "ArtistList_allArtists",
        "kind": "LinkedHandle",
        "name": "allArtists"
      }
    ]
  },
  "params": {
    "cacheID": "e92beed7f87fe725b44e971e9b86f464",
    "id": null,
    "metadata": {},
    "name": "ArtistListPaginationQuery",
    "operationKind": "query",
    "text": "query ArtistListPaginationQuery(\n  $count: Int = 6\n  $cursor: String\n  $displayName_Icontains: String = \"\"\n  $genres: [ID]\n  $instagramFollowers: [ArtistInstagramFollowersRange]\n  $onlyWatching: Boolean = false\n  $orderBy: ArtistOrdering = growth_score_desc\n  $partnershipStatuses: [ArtistPartnershipStatusFilter]\n  $seekingServices: [ArtistSeekingServiceServiceFilter]\n  $spotifyMonthlyListeners: [ArtistSpotifyMonthlyListenersRange]\n  $streamsThisWeek: [ArtistStreamsThisWeekRange]\n  $tiktokFollowers: [ArtistTiktokFollowersRange]\n  $tiktokPosts: [ArtistTiktokPostsRange]\n) {\n  ...ArtistDirectoryCards_allArtists_44iG9q\n}\n\nfragment ArtistDirectoryCard_artist on ArtistNode {\n  user {\n    lastActiveAt\n    id\n  }\n  slug\n  displayName\n  imageUrl\n  partnershipStatus\n  seekingServices {\n    edges {\n      node {\n        service\n        id\n      }\n    }\n  }\n  genre {\n    genre\n    id\n  }\n  latestSpotifyMonthlyListenerCount {\n    current\n    percentChange\n  }\n  latestSpotifyFollowerCount {\n    current\n    percentChange\n  }\n  spotifyProfile {\n    imageUrl\n    url\n    id\n  }\n  latestTiktokFollowerCount {\n    current\n    percentChange\n  }\n  tiktokProfile {\n    url\n    tiktokSounds {\n      ...RowDeal_useTikTokSoundsTotal\n    }\n    id\n  }\n  latestInstagramFollowerCount {\n    current\n    percentChange\n  }\n  instagramProfile {\n    url\n    id\n  }\n}\n\nfragment ArtistDirectoryCards_allArtists_44iG9q on Query {\n  allArtists(first: $count, after: $cursor, orderBy: $orderBy, displayName_Icontains: $displayName_Icontains, onlyWatching: $onlyWatching, genres: $genres, partnershipStatuses: $partnershipStatuses, seekingServices: $seekingServices, streamsThisWeek: $streamsThisWeek, spotifyMonthlyListeners: $spotifyMonthlyListeners, tiktokPosts: $tiktokPosts, tiktokFollowers: $tiktokFollowers, instagramFollowers: $instagramFollowers) {\n    edges {\n      node {\n        id\n        ...ArtistDirectoryCard_artist\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment RowDeal_useTikTokSoundsTotal on TikTokSoundNodeConnection {\n  edges {\n    node {\n      tiktokUrl\n      name\n      mostRecentStat {\n        current\n        previous\n        percentChange\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2348457389637bacd4de1f5105efd91c";

export default node;
